import gql from 'graphql-tag';

export default gql`
  mutation setDeviceToken($deviceToken: DeviceTokenInput!) {
    me {
      updateDeviceToken(deviceToken: $deviceToken)
    }
  }
`;
